// 1. 最前置：ES6 兼容补丁（必须第一行）
import 'babel-polyfill'
import promise from 'es6-promise';
promise.polyfill(); // axios 兼容 IE 需前置

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '../comm/store/store'
import VueBus from 'vue-bus'
import 'es6-promise/auto'
import '../../static/common/reset.css'

// 引入第三方库（补充缺失的引入！）
import axios from 'axios' // ✅ 新增：引入axios
import $ from 'jquery' // ✅ 新增：引入jquery

//引入nprogress
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' //这个样式必须引入
import api from '../comm/api/'
import VueCookies from 'vue-cookies'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import ECharts from 'vue-echarts/components/ECharts.vue'

import * as filters from '../comm/filters' // 全局filter
// 手动引入 ECharts 各模块来减小打包体积
import echarts from 'echarts'  // 导入 ECharts 核心库
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markLine'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import VueQriously from 'vue-qriously'

// 简单配置
//NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false });

Vue.use(VueQriously);

router.beforeEach((to,from,next) => {
  document.title = '工程施工实时监控系统 - 智程易 - 浙江智握领程科技股份有限公司'
  NProgress.start();
  next()
})

router.afterEach(() => {
  NProgress.done()
});

Vue.use(VueBus);
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.use(VueCookies);
Vue.use(ElementUI);
Vue.prototype.$echarts = echarts;
Vue.use(VueVideoPlayer); // ✅ 调整：Vue.use 提前，避免实例化后注册

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

// 注册组件后即可使用
Vue.component('chart', ECharts);

// 可选：挂载常用库到全局，确保旧代码兼容（需在引入后挂载！）
window.Vue = Vue;
window.axios = axios;
window.echarts = echarts;
window.$ = window.jQuery = $;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/civillan/main.js